import React from 'react';
import { FocusTrap, Modal as MantineModal, RemoveScroll } from '@mantine/core';
import clsx from 'clsx';

import styles from './modal.module.scss';

type ModalTypeProps =
  | {
      modalType: 'action';
      actions: React.ReactNode;
      footerAction?: React.ReactNode;
    }
  | { modalType: 'info'; actions?: undefined; footerAction?: undefined };

export type ModalProps = {
  centered?: boolean;
  children: React.ReactNode;
  contentClassName?: string;
  opened: boolean;
  onClose: () => void;
  size?: string | number;
  title?: string | React.ReactNode;
  withCloseButton?: boolean;
  withinPortal?: boolean;
} & ModalTypeProps;

export function Modal({
  actions,
  centered = true,
  children,
  contentClassName,
  modalType,
  opened,
  onClose,
  size,
  title,
  withinPortal = true,
  footerAction,
}: ModalProps) {
  return (
    <MantineModal
      centered={centered}
      classNames={{
        body: styles['body'],
        close: styles['close'],
        content: styles['mantine-content'],
        header: styles['header'],
        overlay: styles['overlay'],
        title: styles['title'],
        inner: clsx(RemoveScroll.classNames.zeroRight, styles['inner']),
      }}
      opened={opened}
      onClose={onClose}
      title={title}
      size={size}
      transitionProps={{ duration: 0 }}
      withCloseButton={modalType === 'info'}
      withinPortal={withinPortal}
      closeOnClickOutside={modalType === 'info'}
    >
      <FocusTrap.InitialFocus />
      <div
        className={clsx(styles['main-content'], contentClassName, {
          [styles['main-content-with-actions']]: modalType === 'action',
        })}
      >
        {children}
      </div>
      {modalType === 'action' && !!footerAction && (
        <div
          className={clsx(
            styles['footer-content'],
            contentClassName,
            styles['footer-content-with-actions']
          )}
        >
          {footerAction}
        </div>
      )}
      {modalType === 'action' && (
        <div className={styles['actions']}>{actions}</div>
      )}
    </MantineModal>
  );
}
